// extracted by mini-css-extract-plugin
export default {"title":"StoryDialog_title__CISD2","boxStart":"StoryDialog_boxStart__dJ40u"};